import React from "react";

const NextPrev = (props) => {
    return (
        <div className="row mt-5">
            <div className="col-6">{props?.step !== 0 && <button className="btn btn-sm btn-success" onClick={() => props?.setStep()} disabled={props?.loading}>{ props?.loading ? <i className="fa-solid fa-spinner fa-spin"></i> : "Prev"}</button>}</div>
            <div className="col-6 text-end">{props?.last >= props?.step && <button className="btn btn-sm btn-success" onClick={props?.onClick} disabled={props?.loading}>{props?.loading ? <i className="fa-solid fa-spinner fa-spin"></i> : "Next"}</button>}</div>
        </div>
    )
}

export default NextPrev;